<template>
  <div class="rightContent" @click="$emit('getCoupen')">
    <a>
      <span>赠送券 :</span>
      <!-- 有件 -->
      <span v-if="item.discountTypes=='give'&&item.giveText.indexOf('件')>-1">满<span>{{item.giveText.match(/\d+(\.\d+)?/g)[0]}}</span>件用￥<span>{{item.giveData}}</span></span>
      <!-- 无件 -->
      <span v-if="item.discountTypes=='give'&&item.giveText.indexOf('件')==-1">满￥<span>{{item.giveText}}</span>用￥<span>{{item.giveData}}</span></span>
      <span class="receive">领券</span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'coupon',
  props:{
    item:Object
  }
}
</script>
<style lang="scss" scoped>
  .rightContent{
    border: 1px solid #fcb7b8;
    background-color: #fee5e5;
    border-radius: 4px;
    padding: 0 10px;
    line-height: 20px;
    margin: 3px 10px 3px 0;
    &:hover{
        background-color: #fef1f1;
    }
    span{
      font-size: 12px;
      font-weight: 600;
      color: #f40002;
      
    }
    .receive{
      padding-left: 8px;
      margin-left: 5px;
      border-left: 1px dotted #fcb7b8;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/coupon.vue